module.exports = __webpack_public_path__ + "static/img/01.11b4c1eb.png";